import React from 'react';
import { Table } from 'react-bootstrap';
import axios from './../../../constants/axios';

class AllFixedAssets extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         items: []
      };
   }

   componentDidMount() {
      axios.get(`fixedAssets/getAllFixedAssets`)
         .then((res) => {
            this.setState({
               items: res.data
            });
         });
   }

   render() {
      const { items } = this.state;
      return (
         <div>
            <h4>Invoice Items</h4>
            <Table>
               <thead>
               <tr>
                  <th>Asset Id</th>
                  <th>Asset Name</th>
                  <th>Initial Value</th>
                  <th>Salvage Value</th>
               </tr>
               </thead>
               <tbody>
               {items.map((item) => (
                  <tr key={item.id} >
                     <td>{item.id}</td>
                     <td>{item.name}</td>
                     <td>{item.initial_value}</td>
                     <td>{item.salvage_value}</td>
                  </tr>
               ))}
               </tbody>
            </Table>
         </div>
      );
   }
}


AllFixedAssets.propTypes = {};


export default AllFixedAssets;



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/FixedAsset/AllFixedAssets.js
 **/